import { Component, EventEmitter, Injector, Output } from '@angular/core';
import { CreateUserDialogComponent } from '@app/users/create-user/create-user-dialog.component';
import { EditUserDialogComponent } from '@app/users/edit-user/edit-user-dialog.component';
import { ResetPasswordDialogComponent } from '@app/users/reset-password/reset-password.component';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { PagedRequestDto, PagedListingComponentBase } from '@shared/paged-listing-component-base';
import { UserDto, UserServiceProxy, UserDtoPagedResultDto } from '@shared/service-proxies/service-proxies';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs';

class PagedUsersRequestDto extends PagedRequestDto {
  keyword: string;
}

@Component({
  selector: 'app-user-select-modal',
  templateUrl: './user-select-modal.component.html',
  styleUrls: ['./user-select-modal.component.css'],
  animations: [appModuleAnimation()]
})
export class UserSelectModalComponent extends PagedListingComponentBase<UserDto> {
  users: UserDto[] = [];
  keyword = '';
  advancedFiltersVisible = false;
  @Output() onSave = new EventEmitter<UserDto>();
  constructor(
    injector: Injector,
    private _userService: UserServiceProxy,
    private _modalService: BsModalService,
    public bsModalRef: BsModalRef
  ) {
    super(injector);
  }

  createUser(): void {
    this.showCreateOrEditUserDialog();
  }

  clearFilters(): void {
    this.keyword = '';
    this.getDataPage(1);
  }

  protected list(
    request: PagedUsersRequestDto,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    request.keyword = this.keyword;

    this._userService
      .getAll(
        request.keyword,
        true,
        request.skipCount,
        request.maxResultCount
      )
      .pipe(
        finalize(() => {
          finishedCallback();
        })
      )
      .subscribe((result: UserDtoPagedResultDto) => {
        this.users = result.items;
        this.showPaging(result, pageNumber);
      });
  }

  protected delete(): void {
 
  }

  private showCreateOrEditUserDialog(): void {
    let createOrEditUserDialog: BsModalRef;
      createOrEditUserDialog = this._modalService.show(
        CreateUserDialogComponent,
        {
          class: 'modal-lg',
        }
      );
    createOrEditUserDialog.content.onSave.subscribe((res) => {
      if(res != null){
        this.selected(res);
      }
    });
  }
  
  selected(User:UserDto){
    this.onSave.emit(User);
    this.bsModalRef.hide();
  }
}
